import { render, staticRenderFns } from "./relatedBusiness.vue?vue&type=template&id=59d1f90e&scoped=true"
import script from "./relatedBusiness.vue?vue&type=script&lang=js"
export * from "./relatedBusiness.vue?vue&type=script&lang=js"
import style0 from "./relatedBusiness.vue?vue&type=style&index=0&id=59d1f90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1f90e",
  null
  
)

export default component.exports